import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-percent',
    templateUrl: './percent.component.html',
    styleUrls: ['./percent.component.css'],
    standalone: false
})
export class PercentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}

